export const ENDPOINTS = {
  GET_ACCOUNT_EXECUTIVES: '/api/v1/users/accountExecutives',
  GET_ACCOUNT_MANAGERS: '/api/v1/users/accountManagers',
  GET_TYPE_OF_PURCHASE_LIST: '/api/v1/typeOfPurchases',
  GET_ADVERTISERS: '/api/v1/advertisers',
  GET_BOOKING_SHEET: '/api/v1/bookingSheet',
  DOWNLOAD_BOOKING: '/api/v1/bookingSheet/download',
  BOOKINGS_ENDPOINT: '/api/v1/bookings',
  BATCH_UPDATE_BOOKINGS: '/api/v1/bookings/batch',
  GET_SLOT_PACKAGES: 'api/v1/inventory/slots/gpNGP',
  CHECK_INVENTORY_EXIST: '/api/v1/inventory/slots/gpNGP',
};

export const EndpointQueryKeys = {
  GET_ACCOUNT_EXECUTIVES: 'account-executives',
  GET_ACCOUNT_MANAGERS: 'account-managers',
  GET_TYPE_OF_PURCHASE_LIST: 'type-of-purchase',
  GET_ADVERTISERS: 'advertisers',
  GET_BOOKING_SHEET: 'booking-sheet',
  CREATE_BOOKING: 'create-booking',
  UPDATE_BOOKING: 'update-booking',
  GET_BOOKING_DETAILS: 'get-booking-details',
  GET_SLOT_PACKAGES: 'slot-packages',
  CHECK_INVENTORY_EXIST: 'check-inventory-exist',
};
